import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Banners } from '@sorare/core/src/components/layout/Banners';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { useTour } from '@sorare/core/src/hooks/useTour';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/nba';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { primaryMarketFilters } from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';

const PrimaryMarket = () => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();

  useTitleAndDescription(
    metadatas.newSignings.title,
    metadatas.newSignings.description
  );

  const cardSorts = createCardSorts({
    indexPrefix: 'Cards On Sale',
    withHighestAverageScore: true,
  });

  const defaultSort = 'Cards On Sale Ending Soon';

  const filters = useDefaultFilters({
    auction: true,
  });

  return (
    <>
      {!!(!isIosApp || isMarketAuthorizedIosApp) && <Banners />}
      <MarketRoot>
        <Vertical gap={2}>
          <NBACardSearch
            sorts={cardSorts}
            defaultSort={defaultSort}
            cardFilters={primaryMarketFilters}
            defaultFilters={filters}
            analyticsTags={['NewSignings', 'NBA']}
            onlyPrimary
            removeFinishedAuctions
            filtersTour={useTour(LIFECYCLE.newSignings, 'filters')}
            cardsTour={useTour(LIFECYCLE.newSignings, 'cards')}
            hideSorareUser
          />
        </Vertical>
      </MarketRoot>
      {!!isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};
export default PrimaryMarket;
